import { createFileRoute } from "@tanstack/react-router";
import { AgentSkillsIndexRoute } from "@/components/agents/agent-skills-route";

export const Route = createFileRoute("/$owner/agents/$agentId/skills/")({
	component: AgentSkillsIndexPage,
});

function AgentSkillsIndexPage() {
	const { owner, agentId } = Route.useParams();
	return <AgentSkillsIndexRoute owner={owner} agentId={agentId} />;
}